var React = require('react');

function ImpressionFrancaiseSmall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .st0B {\n        fill: #f9f9f9;\n      }\n\n      .st1B {\n        fill: #428bc1;\n      }\n\n      .st2B {\n        fill: #ed4c5c;\n      }\n    ")),React.createElement("path",{"className":"st1B","d":"M0,21.04c0,9.16,5.86,16.95,14.03,19.84V1.2C5.86,4.09,0,11.88,0,21.04Z","key":1}),React.createElement("path",{"className":"st2B","d":"M42.09,21.04c0-9.16-5.86-16.95-14.03-19.84v39.68c8.17-2.89,14.03-10.68,14.03-19.84Z","key":2}),React.createElement("path",{"className":"st0B","d":"M14.03,40.88c2.19.78,4.55,1.2,7.01,1.2s4.82-.43,7.01-1.2V1.2c-2.19-.78-4.55-1.2-7.01-1.2s-4.82.43-7.01,1.2v39.68Z","key":3})]);
}

ImpressionFrancaiseSmall.defaultProps = {"id":"Calque_1","version":"1.1","viewBox":"0 0 42.09 42.09"};

module.exports = ImpressionFrancaiseSmall;

ImpressionFrancaiseSmall.default = ImpressionFrancaiseSmall;
